import { VALIDATION_ERRORS } from './constants';
import errorsFactory from '../../../utils/errorsFactory';
import getXlsxColumnsWidth from '../../../utils/getXlsxColumnsWidth';
import { getWorkSheetWidth } from '../../../utils/workSheetHelper';

const MIN_NUMBER_COLUMNS = 3;
const MAX_NUMBER_COLUMNS = 4;

export default workbook => {
  const workSheet = workbook.worksheets[0];
  const range = workSheet['!ref'];

  const width = getWorkSheetWidth(range);

  if (width) {
    const realWidth = getXlsxColumnsWidth(width);

    if (realWidth > MAX_NUMBER_COLUMNS || realWidth < MIN_NUMBER_COLUMNS) {
      throw errorsFactory.ValidationError(VALIDATION_ERRORS.WORKSHEET_WIDTH);
    }
  } else {
    throw errorsFactory.ValidationError(VALIDATION_ERRORS.WORKSHEET_WIDTH);
  }
};
